
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link/Link';
import messages from '../../locale/messages';
import bt from "../commonStyle.css"
import s from './DashboardCards.css'

const DashboardCards = ({ title, icon, content, link, cardKey }) => {
    return (
        <div className={s.dashboardCardContainer}>
            <div className={s.dashboardCardTitle}>{title}</div>
            <div className={s.dashboardCardSubWrapper}>
                <div className={cx(s.dashboardCardSubImgContainer, `dashboardCardSubImgContainer${cardKey + 1}`)}>
                    <img src={icon} alt="icon" />
                </div>
                <div className={s.dashboardCardSubContent}>{content}</div>
                <Link to={link} className={bt.viewAllLink}>
                    <FormattedMessage {...messages.view} />
                </Link>
            </div>
        </div>
    );
};

DashboardCards.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    content: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
};

export default withStyles(bt, s)(DashboardCards);